module.exports = __webpack_public_path__ + "media/assets/images/personas/eva-38faea3677a1996673fcaa9572a3b01f.jpg";